import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        api: "https://info-sites.mskobr.ru",
        cash: "/api/cashes.json",
        eoId: false,
        data: false,
        period: false,
    },


    mutations: {

        setEoId(state, value) {
            this.state.eoId = value
        },

        setData(state, value){
            this.state.data = value
        },

        setPeriod(state, value){
            this.state.period = value
        },

    },


    actions: {

        getData() {
            Axios({
                method:"get",
                url: this.state.api + this.state.cash + "?eoId=" + this.state.eoId
            }).then((res)=>{
                if( res.status == 200 && res.data.response == "success" ){
                    this.commit("setData", res.data.data)
                    this.commit("setPeriod", res.data.period)
                }
            }).catch((err)=>{
                console.log(err)
            })


        },

    }
})
